<template>
  <div>
    <div class="content d-flex flex-column mt-2">
      <div class="d-flex row mx-2 mb-2 align-items-center">
        <div class="header col">
          <h3 class="h3 bold">Arquivos</h3>
        </div>
      </div>
      <div class="section border rounded p-3">       
        <div class="row">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexos do Projeto</h4>
            <g-file-picker
              :value="anexos"
              @update:value="$emit('update:anexos', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="!canEdit"
              :show-download="true"
              :max-file-size="10485760"
            />
          </div>
        </div>        
        <div class="row mt-4">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexo do Cronograma</h4>
            <g-file-picker
              :value="anexoCronograma"
              @update:value="$emit('update:anexoCronograma', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="!canEdit"
              :show-download="true"
              :max-file-size="10485760"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="anexoAnalise && anexoAnalise.length">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexos da Ficha de Análise</h4>
            <g-file-picker
              :value="anexoAnalise"
              label="Arquivos anexados na ficha de análise"
              multiple
              :disabled="true"
              :show-download="true"
              :hide-upload-button="true"
              empty-message="Não existem arquivos da ficha de análise"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexo de Transmissão</h4>
            <g-file-picker
              :value="anexoTransmissao"
              @update:value="$emit('update:anexoTransmissao', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="!canEdit || isClient"
              :show-download="true"
              :hide-upload-button="isClient"
              :max-file-size="10485760"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="showSpecialAttachments">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexo Comprobatório</h4>
            <g-file-picker
              :value="anexoComprobatorio"
              @update:value="$emit('update:anexoComprobatorio', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="true"
              :show-download="true"
              :hide-upload-button="true"
              empty-message="Não existem arquivos para o anexo comprobatório"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="showSpecialAttachments">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexo Comprobatório de Terceiros</h4>
            <g-file-picker
              :value="anexoComprobatorioTerceiro"
              @update:value="$emit('update:anexoComprobatorioTerceiro', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="true"
              :show-download="true"
              :hide-upload-button="true"
              empty-message="Não existem arquivos para o anexo comprobatório de terceiros"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="showSpecialAttachments">
          <div class="col-12">
            <h4 class="text-h6 mb-2">Anexo Comprobatório de Material de Consumo</h4>
            <g-file-picker
              :value="anexoComprobatorioMateriais"
              @update:value="$emit('update:anexoComprobatorioMateriais', $event)"
              label="Adicionar arquivos"
              multiple
              :disabled="true"
              :show-download="true"
              :hide-upload-button="true"
              empty-message="Não existem arquivos para o anexo comprobatório de material de consumo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UserTypeEnum } from "@/core/enums/user-types";
import { mapGetters } from "vuex";

export default {
  components: {
    "g-file-picker": () => import("@/components/g-file-picker.vue"),
  },
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    anexos: {
      type: Array,
      default: () => []
    },
    anexoTransmissao: {
      type: Array,
      default: () => []
    },
    anexoComprobatorio: {
      type: Array,
      default: () => []
    },
    anexoComprobatorioTerceiro: {
      type: Array,
      default: () => []
    },
    anexoComprobatorioMateriais: {
      type: Array,
      default: () => []
    },
    anexoCronograma: {
      type: Array,
      default: () => []
    },
    isClient: {
      type: Boolean,
      default: false
    },
    anexoAnalise: {
      type: Array,
      default: () => []
    },
  },
  data() { 
    return {}
  },
  computed: {
    ...mapGetters(["user"]),
    showSpecialAttachments() {
      const allowedRoles = [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.CONSULTOR,
        UserTypeEnum.CLIENTE_ADMINISTRADOR,
        UserTypeEnum.CLIENTE_CONSULTOR,
      ];
      return this.user && allowedRoles.includes(this.user.tipo_usuario);
    },
  },
}
</script>

<style scoped>
</style>
